import React from "react";
import {useSelector} from "react-redux";
import Stack from "./Stack";

const StrategyStacks = ({ isInteractive, editStrategy }) => {
  const { vision, goal, success, mission } = useSelector(
    (state) => state.strategy
  );

  const data = [
    {
      id: "success",
      label: " Nos valeurs",
      value: success,
    },
    {
      id: "duty",
      label: " Notre mission",
      value: mission,
    },
    {
      id: "vision",
      label: " Notre vision",
      value: vision,
    },
    {
      id: "goal",
      label: " Notre ambition",
      value: goal,
    },
  ];
  return (
    <>
      {data.map((d) => (
        <Stack
          key={d.id + "/" + d.value}
          id={d.id}
          label={d.label}
          value={d.value}
          editStrategy={editStrategy}
          isInteractive={isInteractive}
        />
      ))}
    </>
  );
};

export default StrategyStacks;
